import React from 'react';
import PortfolioBlock from "./PortfolioBlock";
import {Box, Grid} from "@mui/material";
import {info} from "../../info/Info";

export default function Work({innerRef}) {
    return (
        <Box id={'work'} ref={innerRef} mt={12}>
            <Grid container display={'flex'} justifyContent={'center'}>
                {info.work.map((project, index) => (
                   <Grid item xs={12} md={6} key={index}>
                       <PortfolioBlock image={project.image} live={project.live} source={project.source} title={project.title} buttonText={project.buttonText || 'View'} icon={project.icon || 'fa fa-external-link'} />
                   </Grid>
                ))}
            </Grid>
        </Box>
    );
};